// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
import { LegacyPowerUps } from 'app/scripts/data/legacy-power-ups';
import { CalendarSettingsView } from 'app/scripts/views/power-ups/CalendarSettingsView';
import { CardAgingSettingsView } from 'app/scripts/views/power-ups/CardAgingSettingsView';
import { VotingSettingsView } from 'app/scripts/views/power-ups/VotingSettingsView';

export const DirectoryLegacyPowerUps = [
  {
    name: 'voting',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    settingsView(model: any) {
      return new VotingSettingsView({ model });
    },
    id: LegacyPowerUps.voting,
  },
  {
    name: 'cardAging',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    settingsView(model: any) {
      return new CardAgingSettingsView({ model });
    },
    id: LegacyPowerUps.cardAging,
  },
  {
    name: 'calendar',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    settingsView(model: any) {
      return new CalendarSettingsView({ model });
    },
    id: LegacyPowerUps.calendar,
  },
];
